import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white expected-earnings-box" }
const _hoisted_2 = {
  class: "card-body pb-0 letter-spacing d-flex justify-content-between align-items-start",
  style: {"min-height":"205px"}
}
const _hoisted_3 = { class: "p-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Ganadores del Kit ", -1)
const _hoisted_5 = { class: "fw-black mb-12 lh-1 mt-30" }
const _hoisted_6 = { class: "list ps-0 mb-0 list-unstyled mt-15" }
const _hoisted_7 = { class: "text-black fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.totalWinners), 1),
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cityWinners, (city, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "text-muted position-relative fw-medium",
              key: index
            }, [
              _createTextVNode(_toDisplayString(city.name) + " - ", 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(city.count), 1)
            ]))
          }), 128))
        ])
      ]),
      _createVNode(_component_apexchart, {
        type: "donut",
        height: "200",
        options: _ctx.earningChart,
        series: _ctx.cityWinners.map((city) => city.count)
      }, null, 8, ["options", "series"])
    ])
  ]))
}